
    
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ServeCopyOfOrderOnOtherPartyOther extends Vue {    

    @Prop({required: true})
    instructionsStep!: string;

    @Prop({required: true})
    applicationName!: string;

    @Prop({default: false})
    sevenDays!: boolean;

    @Prop({default: false})
    includesEfsp!: boolean; 

    dataReady = false;
    efspShouldBeListed = false;

    mounted(){
        this.dataReady = false;
        this.efspShouldBeListed = this.applicationName == 'Affidavit – General' && this.includesEfsp;        
    }    
    
}
